import { NgModule } from "@angular/core";
import { SafeUrlPipe } from "./safeUrl/safe-url.pipe";
import { TranslateWithKeysPipe } from "./translateWithKeys/translate-with-keys.pipe";
import { CommonModule } from "@angular/common";


@NgModule({
  declarations: [
    SafeUrlPipe,
    TranslateWithKeysPipe,
  ],
  imports: [
    CommonModule
  ],
  exports:[
    SafeUrlPipe,
    TranslateWithKeysPipe,
    ]
})
export class PipeModule{ }
